export default "__VITE_PUBLIC_ASSET__826b1d2c__"